import { useEffect, useState } from 'react'
import _ from 'lodash'
import { Modal } from '@vzmi/shp_shared_compo'
import { Field, formDecorator } from '../../../../Common/forms'
import { InputCountField } from '../../../../Common/Form'
import { getFormValues } from '../../../Common/ProposalForm/Shared/util'
import styles from './index.css'

const FORM_CONFIG = {
  form: 'UPDATE_FIRST_LAYER_MODAL'
}

export const getDuplicatedMapBySku = formValues => {
  const duplicatedMapBySku = _.flow(
    () => _.get(formValues, 'models', []),
    formModels => _.groupBy(formModels, 'spec.selectedValue'),
    groupedFormModels => _.concat(
      ..._.filter(_.values(groupedFormModels), formModels => _.size(formModels) > 1)
    ),
    duplicatedModels => _.keyBy(duplicatedModels, 'sku')
  )()
  return duplicatedMapBySku
}

export const validate = (model, countLimit, duplicatedMapBySku) => (value, formValues) => {
  const valueSize = _.size(value)
  if (valueSize === 0) {
    return '欄位不可為空'
  }

  if (valueSize > countLimit) {
    return `最多 ${countLimit} 個字`
  }

  if (model.sku in duplicatedMapBySku) {
    return '名稱不可重複'
  }

  return null
}

const UpdateFirstLayerModal = props => {
  const {
    visible,
    handleSubmit,
    initialize,
    onOk,
    onCancel,
    models = [],
    countLimitMap = {},
    reduxFormState
  } = props
  const [duplicatedMapBySku, setDuplicatedMapBySku] = useState({})

  const onFieldChange = (e, newValue, oldValue, fieldName) => {
    const newFormValues = _.cloneDeep(getFormValues(reduxFormState))
    _.set(newFormValues, fieldName, newValue)
    const newDuplicatedMapBySku = getDuplicatedMapBySku(newFormValues)
    setDuplicatedMapBySku(newDuplicatedMapBySku)
  }

  // 每次打開時重置第一層屬性名稱
  useEffect(() => {
    if (visible) {
      initialize({ models })
    }
  }, [initialize, visible, models])

  return (
    <Modal
      visible={visible}
      title='修改第一層屬性項目顯示名稱'
      onOk={handleSubmit(onOk)}
      onCancel={onCancel}
      className={styles.model}
    >
      {models.map((model = {}, index) => {
        const { sku } = model
        const countLimit = countLimitMap[sku]
        return (
          <div
            key={sku}
            className={styles.selectedValueInput}
          >
            <Field
              name={`models[${index}].spec.selectedValue`}
              component={InputCountField}
              onChange={onFieldChange}
              countLimit={countLimit}
              validate={[validate(model, countLimit, duplicatedMapBySku)]}
              fullWidth
              absoluteError
            />
          </div>
        )
      })}
    </Modal>
  )
}

export default formDecorator(FORM_CONFIG)(UpdateFirstLayerModal)
